import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ILinkInfo } from '../../classes/page-title-parameters';

@Component({
    selector: 'page-headline',
    templateUrl: './page-headline.component.html',
    styleUrls: ['./page-headline.component.scss'],
})
export class PageHeadlineComponent implements OnInit {
    @Input() linkTitle: string;
    @Input() module: string;
    @Input() moduleIcon: string;
    @Input() moduleLink: string;
    @Input() pageTitle: string;
    @Input() linkArray?: ILinkInfo[];

    constructor(public _router: Router) {}

    ngOnInit() {}

    onClick(routerUrl: string) {
        this._router.navigate(['']).then(() => {
            this._router.navigate([routerUrl]);
        });
    }
}
